export default __webpack_public_path__ + "static/media/hoang.eb349277.png";